// import Leaflet JS
import "leaflet/dist/leaflet"
import "leaflet.markercluster/dist/leaflet.markercluster"
import "leaflet-fullscreen/dist/Leaflet.fullscreen"

var timerMap;
var map;
var markers;
var pin;

$("#map").each(function () {
    var zoomInTitle = $(this).attr("data-zoomInTitle");
    var zoomOutTitle = $(this).attr("data-zoomOutTitle");
    var fullscreenTitleFalse = $(this).attr("data-fullscreenTitleFalse");
    var fullscreenTitleTrue = $(this).attr("data-fullscreenTitleTrue");

    map = L.map('map', {
        minZoom: 2,
        maxZoom: 18,
        scrollWheelZoom: false
    });

    map.setView([50.838825, 4.383464], 5);

    var osmLayer = L.tileLayer('https://gisco-services.ec.europa.eu/maps/tiles/OSMCartoCompositeEN/EPSG3857/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://ec.europa.eu/eurostat/web/gisco/overview" target="_blank">EC-GISCO</a> | &copy; <a href="https://openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a>'
    }).addTo(map);

    map.zoomControl.remove();
    var zoom = L.control.zoom({
        zoomInTitle: zoomInTitle,
        zoomOutTitle: zoomOutTitle
    }).addTo(map);

    map.addControl(new L.Control.Fullscreen({
        title: {
            'false': fullscreenTitleTrue,
            'true': fullscreenTitleFalse
        }
    }));

    $(this).bind('mousewheel DOMMouseScroll', function (event) {
        event.stopPropagation();
        if (event.ctrlKey == true) {
            event.preventDefault();
            map.scrollWheelZoom.enable();
            $('.map-scroll').removeClass('scrolled');
            setTimeout(function () {
                map.scrollWheelZoom.disable();
            }, 1000);
        } else {
            map.scrollWheelZoom.disable();
            $('.map-scroll').addClass('scrolled');

            if (navigator.platform.toUpperCase().indexOf("MAC") >= 0) {
                $('.map-scroll span.scroll').addClass('d-none');
                $('.map-scroll span.scrollMac').removeClass('d-none');
            }

        }

        clearTimeout(timerMap);
        timerMap = setTimeout(function () {
            $('.map-scroll').removeClass('scrolled');
        }, 2000);

    });

    $(this).bind("touchstart", onTwoFingerDrag);
    $(this).bind("touchend", onTwoFingerDrag);

    if($(this).hasClass("map-award")) {
        pin = L.icon({
            iconUrl: '/images/svg/pin-award.svg',
            shadowUrl: '/images/png/marker-shadow.png',
            iconSize: [50, 50], // size of the icon
            iconAnchor:   [25, 50], // The coordinates of the "tip" of the icon
            shadowSize: [80, 50], // size of the shadow
            shadowAnchor: [25, 50],  // the same for the shadow
            popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
        });

    }else {
        pin = L.icon({
            iconUrl: '/images/svg/pin-event.svg',
            shadowUrl: '/images/png/marker-shadow.png',
            iconSize: [50, 50], // size of the icon
            iconAnchor:   [25, 50], // The coordinates of the "tip" of the icon
            shadowSize: [80, 50], // size of the shadow
            shadowAnchor: [25, 50],  // the same for the shadow
            popupAnchor: [0, 0] // point from which the popup should open relative to the iconAnchor
        });
    }

    markers = L.markerClusterGroup({ showCoverageOnHover: false });

    window.markers = markers;
    window.map = map;
    window.pin = pin;
});


function onTwoFingerDrag(e) {

    if (e.type === 'touchstart' && e.touches.length === 1) {
        map.dragging.disable();
        map.scrollWheelZoom.disable();
        $('.map-scroll').addClass('scrolled');
        $('.map-scroll span.scroll').addClass('d-none');
        $('.map-scroll span.touch').removeClass('d-none');
    } else {
        map.dragging.enable();
        map.scrollWheelZoom.enable();
        $('.map-scroll').removeClass('scrolled');
    }

    clearTimeout(timerMap);
    timerMap = setTimeout(function () {
        $('.map-scroll').removeClass('scrolled');
    }, 2000);
}